const tabs = {
  NewActionPlanList: () => import('@/views/action-plan/action-plan-tabs/shared/plans-list')
}

const state = {
  currentTab: tabs.NewActionPlanList,
  tabs
}

const mutations = {
  SET_TABS: (state, tab) => {
    state.currentTab = state.tabs[tab]
  }
}

const actions = {
  setTabs({ commit }, tab) {
    commit('SET_TABS', tab)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
